import React from "react";

const CustomChatLoader = () => {
  return (
    <div className="timeline-loader-background">
      <div className="timeline-loader-background-masker header-top"></div>
      <div className="timeline-loader-background-masker header-left"></div>
      <div className="timeline-loader-background-masker header-right"></div>
      <div className="timeline-loader-background-masker header-bottom"></div>
      <div className="timeline-loader-background-masker subheader-left"></div>
      <div className="timeline-loader-background-masker subheader-right"></div>
      <div className="timeline-loader-background-masker subheader-bottom"></div>
      <div className="timeline-loader-background-masker content-top"></div>
      <div className="timeline-loader-background-masker content-first-end"></div>
      <div className="timeline-loader-background-masker content-second-line"></div>
      <div className="timeline-loader-background-masker content-second-end"></div>
      <div className="timeline-loader-background-masker content-third-line"></div>
      <div className="timeline-loader-background-masker content-third-end"></div>
    </div>
  );
};

export default CustomChatLoader;
